import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import PrintPurchaseOrder from "./PrintPurchaseOrder";
import { useDispatch, useSelector } from "react-redux";
import { useLoadPartCandidatePoOrdersQuery } from "../../app/store/partnerApiSlice";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import {
  getPoOrderDocumentData,
  loadPoOrderdownloadDocument,
  poOrderDownloadDataRecevied,
} from "../../app/store/documents";
import config from "../../config.json";
import { getAlert } from "../../Services/appAlerts";


const PURCHASE_ORDER_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "1040px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid #e2e8f0",
    background: "#ffffff"
  },
  headerRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    border: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "17px",
    flexShrink: 0
  },
  eyebrow: {
    margin: "0 0 3px",
    color: "#4f46e5",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase"
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: 1.15
  },
  subtitle: {
    margin: "4px 0 0",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid #e2e8f0",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px",
    background: "#ffffff"
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  summaryCard: {
    borderRadius: "0px",
    border: "1px solid #e2e8f0",
    background: "#ffffff",
    padding: "13px 14px",
    boxShadow: "none"
  },
  summaryLabel: {
    margin: "0 0 6px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  summaryValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "22px",
    fontWeight: 600,
    lineHeight: 1.1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "12px"
  },
  toolbarText: {
    margin: 0,
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap"
  },
  tableShell: {
    border: "1px solid #e2e8f0",
    borderRadius: "0px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "none"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#f8fafc",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    padding: "13px 14px",
    textTransform: "uppercase",
    verticalAlign: "top"
  },
  tableCell: {
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
    color: "#334155",
    fontSize: "13px",
    padding: "16px 14px",
    verticalAlign: "middle",
    fontWeight: 600
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "34px",
    height: "30px",
    borderRadius: "0px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 600
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    borderRadius: "0px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 600,
    textDecoration: "none",
    whiteSpace: "nowrap",
    lineHeight: 1.2
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "0px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 600,
    border: "1px solid transparent",
    marginBottom: "7px"
  },
  successPill: {
    color: "#0f172a",
    backgroundColor: "#2dce898c",
    borderColor: "#2dce89"
  },
  warningPill: {
    color: "#0f172a",
    backgroundColor: "#ffd600",
    borderColor: "#ffd600"
  },
  mutedText: {
    display: "block",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5,
    fontWeight: 600
  },
  emptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "54px",
    height: "54px",
    margin: "0 auto 12px",
    borderRadius: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "22px"
  },
  emptyTitle: {
    margin: "0 0 6px",
    color: "#0f172a",
    fontSize: "16px",
    fontWeight: 600
  },
  emptyText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0,
    fontWeight: "normal"
  },
  modalFooter: {
    padding: "14px 22px 18px",
    borderTop: "1px solid #e2e8f0",
    background: "#ffffff"
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  cardList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  poCard: {
    display: "grid",
    gridTemplateColumns: "38px minmax(0, 1fr) auto",
    alignItems: "center",
    gap: "14px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "0px",
    boxShadow: "none",
  },
  poIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    border: "1px solid #e2e8f0",
    fontSize: "16px",
  },
  poTitleLine: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  poNameLink: {
    color: "#2563eb",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: 1.25,
    cursor: "pointer",
    textDecoration: "none",
    background: "none",
    border: "none",
    padding: 0,
    outline: "none",
    textAlign: "left",
    display: "inline-block",
    transition: "color 0.2s ease",
  },
  poMeta: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "6px",
    color: "#64748b",
    fontSize: "12px",
    fontWeight: 600,
  },
  poMetaItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    minWidth: 0,
    maxWidth: "320px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  poActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  poButton: {
    minHeight: "38px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: "#ffffff",
    border: "1px solid #cbd5e1",
    padding: "8px 16px",
    borderRadius: "0px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#334155",
    whiteSpace: "nowrap",
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  poViewButton: {
    minHeight: "26px",
    height: "26px",
    padding: "3px 9px",
    fontSize: "11.5px",
    borderRadius: "0px",
  },
  poPrimaryButton: {
    background: "#2563eb",
    color: "#ffffff",
    borderColor: "#2563eb",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
  },
  poStatusStack: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
  poStatusDate: {
    color: "#94a3b8",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1.1,
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  poDivider: {
    width: "1px",
    height: "24px",
    background: "#cbd5e1",
    margin: "0 4px",
  },
  poEsignTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    width: "fit-content",
    padding: "2px 8px",
    borderRadius: "0px",
    background: "rgba(37, 99, 235, 0.08)",
    border: "1px solid rgba(37, 99, 235, 0.15)",
    color: "#1d4ed8",
    fontSize: "11px",
    fontWeight: 600,
  },
};

const PurchaseOrders = (props) => {
  const {
    handlePoShowHide,
    poShowHide,
    candidateObj,
    handleRefreshPartnerCandidates,
  } = props;

  const [poAction, setPoAction] = useState("");
  const [genShowHide, setGenShowHide] = useState(false);
  const [selectedPoOrder, setSelectedPoOrder] = useState(null);
  const [poSignLinkLoadingId, setPoSignLinkLoadingId] = useState(null);
  const [poSignedDocLoadingId, setPoSignedDocLoadingId] = useState(null);
  const [poEsignLinks, setPoEsignLinks] = useState({});

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const poOrderDocumentDataSelector = useSelector(getPoOrderDocumentData);

  const userType = useMemo(() => localStorage.getItem("userType"), []);
  const dispatch = useDispatch();
  const currentUser = useMemo(() => getCurrentUser(), []);
  const currentUserId = currentUser?.id;

  const getEsignBaseUrl = useCallback(() => {
    return window.location.hostname === "localhost"
      ? "http://localhost:5173"
      : (process?.env?.REACT_APP_ESIGN_BASEURL || "http://localhost:5173");
  }, []);

  const getEsignApiBaseUrl = useCallback(() => {
    return process?.env?.REACT_APP_ESIGN_API_BASEURL ||
      process?.env?.REACT_APP_ESIGN_API_URL ||
      (window.location.hostname === "localhost" ? "http://localhost:5005" : getEsignBaseUrl());
  }, [getEsignBaseUrl]);

  const getWorkbenchApiBaseUrl = useCallback(() => {
    return (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");
  }, []);

  const getPoEsignValue = useCallback((poOrder, key) => {
    return poOrder?.[key] ?? poOrder?.[`e${key.substring(1)}`] ?? poOrder?.[`esign${key.replace(/^ESign/, "")}`];
  }, []);

  const getPoEsignDocumentId = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignDocumentId") || poOrder?.eSignDocumentId || poOrder?.esignDocumentId;
  }, [getPoEsignValue]);

  const getPoEsignPreparationToken = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignPreparationToken") || poOrder?.eSignPreparationToken || poOrder?.esignPreparationToken;
  }, [getPoEsignValue]);

  const getPoEsignStatus = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignStatus") || poOrder?.eSignStatus || poOrder?.esignStatus;
  }, [getPoEsignValue]);

  const isPoEsignSigned = useCallback((poOrder) => {
    const status = (getPoEsignStatus(poOrder) || "").replace(/\s+/g, "").toLowerCase();
    return status === "signed" || status === "completed" || !!getPoEsignValue(poOrder, "ESignCompletedDateTime");
  }, [getPoEsignStatus, getPoEsignValue]);

  const hasCurrentUserSignedPo = useCallback((poOrder) => {
    const status = (poOrder?.currentUserSignStatus || "").replace(/\s+/g, "").toLowerCase();
    return status === "signed" || status === "completed";
  }, []);

  const getPoBadge = useCallback((poOrder) => {
    const esignToken = getPoEsignPreparationToken(poOrder);
    const esignDocumentId = getPoEsignDocumentId(poOrder);
    const status = getPoEsignStatus(poOrder);
    const normalized = (status || "").replace(/\s+/g, "").toLowerCase();

    if (esignToken || esignDocumentId) {
      switch (normalized) {
        case "signed":
        case "completed":
          return { text: "Signed", icon: "fa-check-circle", style: PURCHASE_ORDER_STYLES.successPill };
        case "partiallysigned":
          return { text: "Partially Signed", icon: "fa-adjust", style: PURCHASE_ORDER_STYLES.warningPill };
        case "expired":
        case "cancelled":
        case "canceled":
        case "rejected":
          return { text: status, icon: "fa-exclamation-circle", style: { color: "#b91c1c", backgroundColor: "#fef2f2", borderColor: "#fecaca" } };
        default:
          return { text: "Pending Signature", icon: "fa-pencil-square-o", style: PURCHASE_ORDER_STYLES.warningPill };
      }
    }

    return poOrder.partnerSignedData
      ? { text: "Signed", icon: "fa-check-circle", style: PURCHASE_ORDER_STYLES.successPill }
      : null;
  }, [getPoEsignPreparationToken, getPoEsignDocumentId, getPoEsignStatus]);

  const usrType = useMemo(() => {
    if (userType !== "PP") return userType;
    if (!loggedUserDetailsSelector) return "";
    let uType = loggedUserDetailsSelector.partnerType;
    if (uType === "Sub-Contractors") {
      uType = "subcontractor";
    }
    return uType;
  }, [userType, loggedUserDetailsSelector]);

  useEffect(() => {
    if (userType === "PP" && !loggedUserDetailsSelector && currentUserId) {
      dispatch(loadUserDetails(currentUserId));
    }
  }, [dispatch, userType, loggedUserDetailsSelector, currentUserId]);

  const skipPoQuery = !candidateObj?.performerid || !usrType;
  const { data: purchaseOrders = [], refetch: refetchPoOrders } = useLoadPartCandidatePoOrdersQuery(
    { id: candidateObj?.performerid, type: usrType, currentPerformerId: currentUserId },
    { skip: skipPoQuery }
  );

  useEffect(() => {
    const fetchLinks = async () => {
      const newLinks = {};
      let updated = false;
      for (const item of purchaseOrders) {
        const esignToken = getPoEsignPreparationToken(item);
        if (esignToken) {
          let alreadyExists = false;
          setPoEsignLinks(prev => {
            if (prev[item.id]) {
              alreadyExists = true;
            }
            return prev;
          });

          if (!alreadyExists) {
            try {
              const apiBase = getWorkbenchApiBaseUrl();
              const response = await fetch(`${apiBase}/api/ReviewForm/GetPoESignLinks?poId=${item.id}`);
              if (response.ok) {
                const data = await response.json();
                newLinks[item.id] = data;
                updated = true;
              }
            } catch (error) {
              console.error("Error fetching PO esign links", error);
            }
          }
        }
      }
      if (updated) {
        setPoEsignLinks(prev => ({ ...prev, ...newLinks }));
      }
    };

    if (purchaseOrders.length > 0) {
      fetchLinks();
    }
  }, [purchaseOrders, getPoEsignPreparationToken, getWorkbenchApiBaseUrl]);

  const handleGenShowHide = useCallback((obj, action) => {
    if (obj === "save") {
      setGenShowHide(false);
      setPoAction("");
      setSelectedPoOrder(null);
      refetchPoOrders();
      if (handleRefreshPartnerCandidates) {
        handleRefreshPartnerCandidates();
      }
    } else {
      setGenShowHide(prev => !prev);
      setPoAction(action);
      setSelectedPoOrder(obj);
    }
  }, [refetchPoOrders, handleRefreshPartnerCandidates]);

  const handleDownloadFile = useCallback((item, type) => {
    dispatch(loadPoOrderdownloadDocument(item.id, type));
  }, [dispatch]);

  const handleViewPoFile = useCallback((item, type = "") => {
    const apiBaseUrl = getWorkbenchApiBaseUrl();
    const viewUrl = `${apiBaseUrl}/api/${config.GetPoOrderDocument}${item.id}&type=${encodeURIComponent(type)}&inline=true`;
    window.open(viewUrl, "_blank");
  }, [getWorkbenchApiBaseUrl]);

  const handleOpenPoSignLink = useCallback(async (item) => {
    const esignToken = getPoEsignPreparationToken(item);
    if (!esignToken) return;

    try {
      setPoSignLinkLoadingId(item.id);

      // The email lets the API resolve this specific signer, which is what enforces
      // the signing order for sequential purchase orders.
      const userEmail =
        loggedUserDetailsSelector?.performeremail ||
        loggedUserDetailsSelector?.performerEmail ||
        loggedUserDetailsSelector?.email ||
        currentUser?.email ||
        currentUser?.username ||
        currentUser?.unique_name ||
        "";

      const response = await fetch(
        `${getWorkbenchApiBaseUrl()}/api/ReviewForm/GetPoESignSignLink?poId=${item.id}&email=${encodeURIComponent(userEmail)}`
      );
      const data = await response.json().catch(() => null);

      if (response.ok && data?.signingLink) {
        window.open(data.signingLink, "_blank");
        return;
      }

      // This user's email is not on the signer roster for this purchase order.
      const notAuthorized =
        data?.notAuthorized === true ||
        response.status === 403 ||
        /no pending signer/i.test(data?.message || "");
      if (notAuthorized) {
        getAlert("", "You are not authorized to sign this purchase order. Please contact your administrator.", "error");
        return;
      }

      // Sequential signing: the backend withholds the link until earlier signers finish.
      if (response.ok && data?.message) {
        getAlert("", data.message, "info");
        return;
      }

      getAlert("", data?.message || "Unable to create signing link.", "error");
    } catch (error) {
      getAlert("", "Unable to connect to eSign. Please try again.", "error");
    } finally {
      setPoSignLinkLoadingId(null);
    }
  }, [getPoEsignPreparationToken, getWorkbenchApiBaseUrl, loggedUserDetailsSelector, currentUser]);

  // Opens the certified/digital signed PDF when it exists, otherwise the visible signed
  // copy. The final-signed endpoint returns 404 (JSON) until the digital signing step has
  // run, so we probe it before handing the URL to the browser.
  const handleDownloadPoSignedDoc = useCallback(async (item) => {
    const esignToken = getPoEsignPreparationToken(item);
    const esignApiBaseUrl = getEsignApiBaseUrl();
    const links = poEsignLinks[item.id] || {};
    const finalUrl = links.finalSigned || `${esignApiBaseUrl}/api/public/documents/${esignToken}/download/final-signed?inline=true`;
    const visibleUrl = links.visibleSigned || `${esignApiBaseUrl}/api/public/documents/${esignToken}/download/visible-signed?inline=true`;

    try {
      setPoSignedDocLoadingId(item.id);

      let targetUrl = visibleUrl;
      try {
        const probe = await fetch(finalUrl);
        const contentType = probe.headers.get("content-type") || "";
        if (probe.ok && contentType.includes("pdf")) {
          targetUrl = finalUrl;
        }
      } catch {
        // Network/CORS failure - fall back to the visible signed copy.
      }

      window.open(targetUrl, "_blank");
    } finally {
      setPoSignedDocLoadingId(null);
    }
  }, [getPoEsignPreparationToken, getEsignApiBaseUrl, poEsignLinks]);

  useEffect(() => {
    if (poOrderDocumentDataSelector?.uploadUrl) {
      window.open(poOrderDocumentDataSelector?.uploadUrl, "_blank");
      dispatch(poOrderDownloadDataRecevied(null));
    }
  }, [poOrderDocumentDataSelector, dispatch]);

  const handlePoRefresh = useCallback(() => {
    refetchPoOrders();
  }, [refetchPoOrders]);

  const signedCount = useMemo(() => {
    return purchaseOrders.filter((item) => item.partnerSignedData || isPoEsignSigned(item)).length;
  }, [purchaseOrders, isPoEsignSigned]);

  const pendingCount = useMemo(() => {
    return purchaseOrders.filter((item) => !item.partnerSignedData && !isPoEsignSigned(item)).length;
  }, [purchaseOrders, isPoEsignSigned]);

  const candidateName = useMemo(() => {
    return [candidateObj?.performername, candidateObj?.lastName]
      .filter(Boolean)
      .join(" ");
  }, [candidateObj]);

  const renderPurchaseOrderCard = useCallback((item) => {
    const esignToken = getPoEsignPreparationToken(item);
    const esignDocumentId = getPoEsignDocumentId(item);
    const esignApiBaseUrl = getEsignApiBaseUrl();
    const esignSigned = isPoEsignSigned(item);
    const currentUserSigned = hasCurrentUserSignedPo(item);
    const documentSigned = esignSigned || !!item.partnerSignedData;
    // Only offer the visible-signed copy once THIS user has signed through the Customer
    // Portal. A document partially signed elsewhere (e.g. from the Workbench) should not
    // surface "View Signed Document" here until the portal user completes their signature.
    const hasVisibleSignature = currentUserSigned;
    const badge = getPoBadge(item);
    const signDate = getPoEsignValue(item, "ESignCompletedDateTime") || item.partnerSignDateTime;

    return (
      <div key={item.id} style={PURCHASE_ORDER_STYLES.poCard}>
        <div style={PURCHASE_ORDER_STYLES.poIcon}>
          <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
        </div>

        <div>
          <div style={PURCHASE_ORDER_STYLES.poTitleLine}>
            <button
              type="button"
              className="purchase-order-name-link"
              style={PURCHASE_ORDER_STYLES.poNameLink}
              onClick={() => handleViewPoFile(item, "")}
              title="View Purchase Order"
            >
              Purchase Order #{item.id}
            </button>
          </div>
          <div style={PURCHASE_ORDER_STYLES.poMeta}>
            <span style={PURCHASE_ORDER_STYLES.poMetaItem}>
              <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>{" "}
              <Moment format="h:mm a">{item.addedDateTime}</Moment>
            </span>
            {item.ipcsPoName && (
              <span style={PURCHASE_ORDER_STYLES.poMetaItem}>
                <i className="fa fa-file-o" aria-hidden="true"></i> {item.ipcsPoName}
              </span>
            )}
            {(esignToken || esignDocumentId) && (
              <span style={PURCHASE_ORDER_STYLES.poEsignTag}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i> eSign
              </span>
            )}
          </div>
        </div>

        <div style={PURCHASE_ORDER_STYLES.poActions}>
          <span style={PURCHASE_ORDER_STYLES.poStatusStack}>
            {badge && (
              <span style={{ ...PURCHASE_ORDER_STYLES.statusPillBase, ...badge.style, marginBottom: 0 }}>
                <i className={`fa ${badge.icon}`} aria-hidden="true"></i> {badge.text}
              </span>
            )}
            {signDate && (
              <span style={PURCHASE_ORDER_STYLES.poStatusDate}>
                <Moment format="MMM Do YYYY">{signDate}</Moment>{" "}
                <Moment format="h:mm a">{signDate}</Moment>
              </span>
            )}
          </span>

          <span style={PURCHASE_ORDER_STYLES.poDivider}></span>

          {documentSigned ? (
            esignToken ? (
              <button
                type="button"
                style={PURCHASE_ORDER_STYLES.poButton}
                onClick={() => handleDownloadPoSignedDoc(item)}
                disabled={poSignedDocLoadingId === item.id}
              >
                {poSignedDocLoadingId === item.id ? (
                  <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading...</>
                ) : (
                  <><i className="fa fa-certificate" aria-hidden="true"></i> Download Signed Document</>
                )}
              </button>
            ) : (
              <button
                type="button"
                style={PURCHASE_ORDER_STYLES.poButton}
                onClick={() => handleDownloadFile(item, "partner")}
              >
                <i className="fa fa-certificate" aria-hidden="true"></i> Download Signed Document
              </button>
            )
          ) : esignToken ? (
            // The PO is in the eSign flow but not fully signed yet. Let this user sign
            // if it is still their turn, and always offer the visible-signed copy — the
            // final (digitally signed) PDF only exists once every signer has finished.
            <>
              {!currentUserSigned && (
                <button
                  type="button"
                  style={{ ...PURCHASE_ORDER_STYLES.poButton, ...PURCHASE_ORDER_STYLES.poPrimaryButton }}
                  onClick={() => handleOpenPoSignLink(item)}
                  disabled={poSignLinkLoadingId === item.id}
                >
                  {poSignLinkLoadingId === item.id ? (
                    <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Opening...</>
                  ) : (
                    <><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Sign the Document</>
                  )}
                </button>
              )}
              {hasVisibleSignature && (
                <a
                  style={PURCHASE_ORDER_STYLES.poButton}
                  href={poEsignLinks[item.id]?.visibleSigned || `${esignApiBaseUrl}/api/public/documents/${esignToken}/download/visible-signed?inline=true`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-eye" aria-hidden="true"></i> View Signed Document
                </a>
              )}
            </>
          ) : null}
        </div>
      </div>
    );
  }, [getPoEsignPreparationToken, getPoEsignDocumentId, getEsignApiBaseUrl, isPoEsignSigned, hasCurrentUserSignedPo, getPoEsignStatus, getPoBadge, getPoEsignValue, handleViewPoFile, poEsignLinks, poSignLinkLoadingId, handleOpenPoSignLink, handleDownloadFile, handleDownloadPoSignedDoc, poSignedDocLoadingId]);

  return (
    <React.Fragment>
      <Modal
        show={poShowHide}
        size="lg"
        centered
        onHide={() => handlePoShowHide("")}
        dialogClassName="purchase-orders-modal-dialog"
        contentClassName="purchase-orders-modal-content"
      >
        <style>
          {`
            .purchase-orders-modal-dialog {
              max-width: ${PURCHASE_ORDER_STYLES.modalDialog.maxWidth};
            }
            .purchase-orders-modal-content,
            .purchase-orders-modal-dialog .modal-content {
              border-radius: 0px !important;
              overflow: ${PURCHASE_ORDER_STYLES.modalContent.overflow};
              border: ${PURCHASE_ORDER_STYLES.modalContent.border};
              box-shadow: ${PURCHASE_ORDER_STYLES.modalContent.boxShadow};
            }
            .purchase-order-name-link {
              color: #2563eb;
              text-decoration: none;
            }
            .purchase-order-name-link:hover,
            .purchase-order-name-link:focus {
              color: #1d4ed8 !important;
              text-decoration: underline !important;
            }
          `}
        </style>
        <Modal.Header style={PURCHASE_ORDER_STYLES.modalHeader}>
          <div style={PURCHASE_ORDER_STYLES.headerRow}>
            <Modal.Title as="div" style={PURCHASE_ORDER_STYLES.titleWrap}>
              <span style={PURCHASE_ORDER_STYLES.titleIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </span>
              <div>
                <p style={PURCHASE_ORDER_STYLES.eyebrow}>Purchase Orders</p>
                <h2 style={PURCHASE_ORDER_STYLES.title}>
                  {candidateName || "Candidate Purchase Orders"}
                </h2>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={PURCHASE_ORDER_STYLES.closeButton}
              onClick={() => handlePoShowHide("")}
              aria-label="Close purchase orders popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={PURCHASE_ORDER_STYLES.modalBody}>
          <div style={PURCHASE_ORDER_STYLES.toolbar}>
            <button
              className="btn btn-sm"
              style={PURCHASE_ORDER_STYLES.refreshButton}
              onClick={handlePoRefresh}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
            </button>
          </div>
          <div style={PURCHASE_ORDER_STYLES.summaryGrid}>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Total Orders</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{purchaseOrders.length}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Pending eSign</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{pendingCount}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Signed</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{signedCount}</p>
            </div>
          </div>
          {purchaseOrders.length === 0 ? (
            <div style={PURCHASE_ORDER_STYLES.emptyState}>
              <div style={PURCHASE_ORDER_STYLES.emptyIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </div>
              <h4 style={PURCHASE_ORDER_STYLES.emptyTitle}>No purchase orders found</h4>
            </div>
          ) : (
            <div style={PURCHASE_ORDER_STYLES.cardList}>
              {purchaseOrders.map((item) => renderPurchaseOrderCard(item))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={PURCHASE_ORDER_STYLES.modalFooter}>
          <div style={PURCHASE_ORDER_STYLES.footerActions}>
            <button
              type="button"
              style={PURCHASE_ORDER_STYLES.cancelButton}
              onClick={() => handlePoShowHide("")}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {genShowHide && candidateObj?.performerid > 0 && (
        <PrintPurchaseOrder
          genShowHide={genShowHide}
          handleGenShowHide={handleGenShowHide}
          candidateObj={candidateObj}
          poOrder={selectedPoOrder}
          poAction={poAction}
        ></PrintPurchaseOrder>
      )}
    </React.Fragment>
  );
};

export default PurchaseOrders;
